import { observer, inject } from 'mobx-react';
import { useTranslations } from 'next-intl';
import { getPriceDetails, renderPriceInfo, renderWeightPriceInfo } from '@/utils/misc';

const Price = inject('wooCommerceStore')(observer(({
  product,
  productType,
  setProductDisplayType,
  wooCommerceStore,
}) => {
  const { regular_price: regularPrice, weight, weightable: productWeightOption, units_based: productUnitsOption, pack_based: productPackOption } = product;
  const weightUnit = wooCommerceStore.weightUnit || 'kg'; // Default to 'kg' if no setting available
  const tu = useTranslations('Units');

  if (productType === 'simple') {
    const priceDetails = getPriceDetails(product, weightUnit, tu);
    setProductDisplayType(priceDetails.perUnit);
    if (productWeightOption && weight > 0 && regularPrice > 0) {
      return (
        <>
          {renderWeightPriceInfo(priceDetails)}
        </>
      );
    } else if (!productWeightOption && (productUnitsOption || productPackOption)) {
      setProductDisplayType(priceDetails.perUnitDisplay);
      return (
        <>
          {renderPriceInfo(priceDetails)}
        </>
      );
    } else {
      setProductDisplayType(priceDetails.perUnitDisplay);
      return (
        <>
          {renderPriceInfo(priceDetails)}
        </>
      );
    }
  } else if (productType === 'variable' && product) {
    // Handle the pricing display for the selected variation.
    const variationDetails = getPriceDetails(product, weightUnit, tu, productType);
    setProductDisplayType(variationDetails.perUnit);
    if (productWeightOption && weight > 0 && regularPrice > 0) {
      return (
        <>
          {renderWeightPriceInfo(variationDetails)}
        </>
      );
    } else {
      setProductDisplayType(variationDetails.perUnitDisplay);
      return (
        <>
          {renderPriceInfo(variationDetails)}
        </>
      );
    }
  }

  return null;
}));

export default Price;
